<template>
  
  <nav-bar :createAction="true" @create="createScheduling" />

  <main-container>

    <template v-slot>
      <div class="row d-flex justify-content-center">      
      <!-- <v-calendar></v-calendar> -->
      <v-date-picker v-model="date" />
    </div> 

  
    <list-group class="py-2" v-if="schedulings.length > 0">
      <list-item v-for="obj in schedulings" :key="obj.id" v-on:click="updateScheduling(obj.id)">
        <template v-slot:title>
          <h5 class="mb-1 fw-bold">{{ obj.patientName }}</h5> 
          <div>
            <font-awesome-icon title="Excluir Agendamento" icon="trash" class="pointer red" v-on:click="deleteScheduling(obj.id, $event)" />
            <span class="px-2"></span>            
          </div>            
        </template>
        <template v-slot:complement>
          <p class="mb-0">{{`${formatSchedulingDate(obj.startDate)}`}}</p>   
          <p class="mb-0">{{`${formatSchedulingTime(obj.startDate, obj.endDate)}`}}</p>
        </template>
      </list-item>
    </list-group>

    <list-group class="py-2" v-else>
      <list-item>
        <template v-slot:title>
          <div class="d-flex w-100">
            <h5 class="mb-1 fw-bold">Nenhum agendamento encontrado nesta data!</h5>
          </div>
        </template>
      </list-item>
    </list-group>
    </template>    
                
  </main-container>

  <bottom-bar />


</template>

<script>
import {getInstance} from "../../api/api";
import {formatSchedulingDate, formatSchedulingTime} from "../../services/formatters";
import {confirmOperation, showErrorModal, showToastSuccess} from "../../services/popups";
import timeMixins from "../../services/time";
import { useUserStore } from '../../store/user';
import { useSchedulingStore } from '../../store/scheduling';
const api = getInstance();

export default {
    name:"SchedulingsListView",
    mixins:[ timeMixins],
    inject:["mySpinner"],
    setup() {
      const userStore = useUserStore();
      const schedulingStore = useSchedulingStore()

      return { userStore, schedulingStore }
    },
    async mounted() {
      this.preFillFields()      
    },
    data() {
      return {
        schedulings:[],
        date:""
      }
    },
    methods: {
      preFillFields() {
        let lastDate = this.schedulingStore.lastDate;
        
        if (!lastDate)     
          this.date = new Date();
        else
          this.date = lastDate;
      },
      async getSchedulingsByDate() {
        this.mySpinner.loading = true;

        try {
          let response = await api.get("v1/Scheduling/Date", { params: { userId:this.userStore.getUser.id, date:this.shortDateToBackend(this.date) } })          

          this.mySpinner.loading = false;          

          if (!response.data.success) {
            //showErrorModal(response.data.message);
            this.schedulings = [];
          }
          else {
            this.schedulings = response.data.data;
            this.schedulings.sort((a, b) => (b.startDate > a.startDate) ? -1 : ((a.startDate > b.startDate) ? 1 : 0));
          }          
        } catch {
          this.mySpinner.loading = false;
          showErrorModal("Erro ao conectar-se ao servidor!");
        } 

      },
      createScheduling() {
        this.$router.push("/schedulings/create");
      },
      updateScheduling(id)  {
        this.$router.push(`/schedulings/${id}`);
      },
      async deleteScheduling(id, event) {
        event.stopPropagation();  
        
        let go = await this.wantDelete();        
    
        if (!go) { return; }
        
        try {
          let response = await api.delete("v1/Scheduling", { params: { schedulingId:id } });

          this.mySpinner.loading = false;          

          if (!response.data.success) {
            showErrorModal(response.data.message);                          
          }
          else {            
            showToastSuccess("Agendamento excluido com sucesso!");
            this.schedulings.splice(this.schedulings.findIndex((item) => item.id === id), 1);                       
          }          
        } catch {
          this.mySpinner.loading = false;
          showErrorModal("Erro ao conectar-se ao servidor!");
        }        
      },
      async wantDelete() {
        let result = await confirmOperation("Deletar", "Deseja realmente deletar o agendamento ?");
        return result;              
      },      
      formatSchedulingTime,
      formatSchedulingDate  
    },
    watch: {
      async date(newDate, oldDate) {
        if (newDate != oldDate && oldDate && newDate) {          
          await this.getSchedulingsByDate();
          this.schedulingStore.setLastDate(newDate);
        }
      }
    }
}

</script>


<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_schedulings';
</style>
